var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgECActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.625,
    height: 26.133,
    viewBox: "0 0 19.625 26.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:#4e83de;}.b{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.971 -189.961)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.834,1106.227a5.723,5.723,0,1,0,5.717,5.724,5.733,5.733,0,0,0-5.717-5.724Zm-5.248,13.081a4.559,4.559,0,0,0-4.565,4.536v7.7a.817.817,0,0,0,.817.818h18a.817.817,0,0,0,.813-.818v-7.7a4.559,4.559,0,0,0-4.565-4.536Z",
    transform: "translate(14.949 -916.266)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 205.092)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.382)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 9,
    height: 9,
    transform: "translate(0 0.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.657,8.06a.387.387,0,0,0-.548.548L9.266,9.765a.374.374,0,0,0,.551-.019l2.7-3.085a.386.386,0,0,0-.578-.509L9.54,8.928Z",
    transform: "translate(-4.912 -3.936)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.359,5.471a.386.386,0,0,0-.386.386A3.084,3.084,0,1,1,5.888,2.771a3.39,3.39,0,0,1,.733.085A.386.386,0,1,0,6.8,2.108,4.065,4.065,0,0,0,5.888,2,3.856,3.856,0,1,0,9.745,5.856a.386.386,0,0,0-.386-.386Z",
    transform: "translate(-1.26 -1.459)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgECActive);
export default __webpack_public_path__ + "static/media/E_C_Active.2558648298cd9b6f4429f3f632bb1038.svg";
export { ForwardRef as ReactComponent };